var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobebubble({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5226 21.4974C39.4925 19.4829 40.0261 17.2186 39.9991 14.8269C39.9061 6.58493 33.2427 0 25.0002 0C18.673 0 13.2608 3.91748 11.0568 9.4593C10.3751 11.1734 10.3169 13.0429 10.3169 14.9999C10.3169 23.2812 16.719 29.5428 25.0002 29.5805C27.1644 29.5903 29.1169 29.0551 30.9779 28.2397C31.2982 28.0993 31.6538 28.0605 31.9984 28.1199L38.4069 29.4726C39.1392 29.599 39.96 29.5564 39.9983 28.8621C40.0042 28.7548 39.9958 28.6441 39.971 28.532L38.3842 22.6754C38.2966 22.2783 38.3462 21.8638 38.5226 21.4974Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35.3958 21.7096C34.9678 22.3727 34.5398 23.0365 33.9628 23.5331C29.4994 27.3741 23.3887 27.9662 18.3106 24.6885C12.5695 20.9829 11.2941 14.2854 14.9997 8.54422C15.6744 7.49899 16.0855 6.33534 16.9867 5.56892C20.1527 2.8766 24.4983 1.95186 28.4881 3.1256L30.9062 6.61735L36.6575 10.8513C37.8979 14.3444 37.5615 18.3544 35.3958 21.7096Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.8283 10.5216C35.8283 10.5216 36.4202 10.686 36.419 10.686C35.5782 10.7602 34.7481 10.7648 33.9622 10.4703C32.7326 10.1057 31.6237 8.80185 30.3627 10.1479C30.1647 10.4371 29.9583 10.7002 29.7458 10.9326C29.5086 11.1916 29.3159 11.2571 29.0021 11.3989C28.6876 11.5407 28.3453 11.621 27.994 11.6313C27.0264 11.6584 26.2895 11.4042 25.8108 10.5627C25.7981 10.541 25.6688 10.5028 25.6567 10.4805C25.5737 10.3426 25.4423 10.2452 25.3817 10.0944C24.8425 8.75254 25.2132 7.01037 26.9073 6.84323C28.1634 6.69535 28.7109 5.18328 28.6197 4.0684L28.4881 3.12555C29.6006 3.45271 30.6859 3.94345 31.7102 4.60441C33.7884 5.94589 35.3303 7.80486 36.2761 9.90352L35.8283 10.5216Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6605 10.8609C36.6303 10.8651 36.6128 10.8675 36.6116 10.8675C35.7707 10.9418 34.6522 11.1174 33.8663 10.8229C32.6367 10.4583 31.7054 8.94922 30.4444 10.2953C30.2464 10.5844 30.04 10.8476 29.8275 11.08C29.5903 11.339 29.3048 11.5436 28.9909 11.6854C28.6764 11.8273 28.3342 11.9076 27.9829 11.9178C27.0153 11.945 26.1128 11.4361 25.6342 10.5947C25.6215 10.573 25.6094 10.5512 25.5974 10.5289C25.4772 10.3297 25.3801 10.1136 25.3076 9.89027C25.8569 10.5373 26.711 10.9152 27.6183 10.8917C27.9985 10.8814 28.3698 10.8011 28.7102 10.6593C29.0507 10.5174 29.3597 10.3128 29.6168 10.0538C29.8468 9.82145 30.0708 9.55828 30.2851 9.26914C31.6516 7.92307 32.6603 9.43212 33.9925 9.79671C34.642 10.0213 35.5009 9.97236 36.276 9.90355C36.4178 10.2174 36.5458 10.5367 36.6605 10.8609Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8311 20.1077C24.8293 20.1162 24.8275 20.124 24.8251 20.1325C24.6723 20.7409 24.3959 21.3119 24.0289 21.8208C22.9979 23.2508 23.5532 25.3568 23.6631 27.0288C23.6643 27.0427 23.6728 27.1465 23.6872 27.3059L15.9985 21.9747L12.6772 13.8669C12.6905 13.8657 12.6978 13.8651 12.6978 13.8651H12.6984C12.7195 13.8627 12.7412 13.8603 12.763 13.8573C13.9273 13.719 15.743 13.4589 15.8656 15.1073C15.9114 15.7236 16.3871 16.1727 16.8525 16.5192C18.7979 17.4838 20.0559 15.717 21.3796 14.788C22.4583 14.1929 23.9444 14.5786 24.4762 15.723C24.8112 16.2367 24.8118 18.327 24.8939 19.1824C24.9241 19.4926 24.9059 19.8053 24.8311 20.1077Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6874 27.3059C21.435 27.0705 19.2569 26.1923 17.4623 24.8123C17.4623 24.8123 17.4623 24.8117 17.4617 24.8117C16.3726 23.9779 15.4249 22.9608 14.6706 21.816C14.6706 21.8154 14.67 21.8154 14.67 21.8154C14.5999 21.7085 14.5311 21.6005 14.4647 21.4918C14.4641 21.4918 14.4641 21.4912 14.4641 21.4912C13.0675 19.2298 12.4325 16.5131 12.6774 13.8669C12.6914 13.8656 12.6976 13.8651 12.6985 13.8651C12.7197 13.8627 12.7414 13.8603 12.7631 13.8573C13.3239 13.7909 14.0362 13.6955 14.6374 13.7993C14.8474 17.6202 16.8219 21.2902 20.2824 23.5242C21.2917 24.1755 22.3607 24.6614 23.4562 24.9886C23.5148 25.6906 23.6216 26.3914 23.6633 27.0288C23.6645 27.0427 23.6729 27.1465 23.6874 27.3059Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8724 19.3883C32.2651 19.1882 32.9395 18.8033 33.208 18.3403C33.7154 17.5425 34.0095 17.2499 33.8039 16.3265C33.7844 16.193 33.8331 15.585 33.8024 15.4555C33.6345 14.7473 33.2689 14.1565 32.3754 14.31C31.2418 14.6863 31.3439 16.2279 29.1465 16.699C28.7544 16.7871 28.4086 17.0312 28.2037 17.3779C28.2033 17.3775 28.2037 17.3771 28.2033 17.3767C28.0574 17.634 27.9921 17.9241 27.9937 18.2186C27.9975 18.9184 28.5833 19.3511 29.1599 19.7171C30.3639 20.4032 30.9197 19.8656 31.8724 19.3883Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.405 18.5407C33.1364 19.0037 32.3668 19.5391 31.9738 19.7395C31.0213 20.2164 30.16 20.6951 28.9557 20.0087C28.3346 19.6146 27.9399 18.8039 28.0002 18.0566C28.1686 18.3862 28.4155 18.6723 28.7143 18.8619C29.9185 19.5482 30.7799 19.0695 31.7324 18.5927C32.1253 18.3923 32.895 17.8568 33.1636 17.3939C33.5958 16.7142 33.7829 15.912 33.702 15.1188C33.7865 15.3452 33.8402 15.5987 33.877 15.8522C34.0823 16.7752 33.9127 17.7428 33.405 18.5407Z",
    fill: "url(#paint7_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.316895,
    y: 0,
    width: 49.6832,
    height: 49.5806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.67451 0 0 0 0 0.976471 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i",
    x: 10.3169,
    y: 0,
    width: 29.6832,
    height: 31.5806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.08367,
    y1: -30.1722,
    x2: 46.5459,
    y2: -28.1827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 25.1397,
    y1: 26.8204,
    x2: 25.1397,
    y2: 2.62573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A0D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DC1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 30.7854,
    y1: 11.6332,
    x2: 30.7854,
    y2: 3.12555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 30.984,
    y1: 11.9189,
    x2: 30.984,
    y2: 8.72055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 18.7925,
    y1: 27.3059,
    x2: 18.7925,
    y2: 13.7535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 18.1567,
    y1: 27.3059,
    x2: 18.1567,
    y2: 13.7534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 30.9319,
    y1: 20.043,
    x2: 30.9319,
    y2: 14.2856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 30.9781,
    y1: 20.3515,
    x2: 30.9781,
    y2: 15.1188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobebubble);
export default __webpack_public_path__ + "static/media/globebubble.9dab2cf10a6d5fca90b248c8a51ccaea.svg";
export { ForwardRef as ReactComponent };